import { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";

const API_BASE_URL = process.env.REACT_APP_API_URL || "";

const useCrearPregunta = ({ nivelId: nivelIdProp } = {}) => {
  const [niveles, setNiveles] = useState([]);
  const [pregunta, setPregunta] = useState({
    tema_id: null,
    nivel_id: null, // 👈 se rellenará según URL o fallback
    texto_pregunta: "",
    tipo_pregunta: "opcion_multiple",
    limite_tiempo: 60,
    retroalimentacion: "",
    respuestas: [
      { texto_respuesta: "", es_correcta: false },
      { texto_respuesta: "", es_correcta: false },
      { texto_respuesta: "", es_correcta: false },
      { texto_respuesta: "", es_correcta: false },
    ],
  });

  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const temaId = searchParams.get("tema");
    const nivelId = nivelIdProp || searchParams.get("nivel");

    if (temaId) {
      setPregunta((prev) => ({
        ...prev,
        tema_id: parseInt(temaId),
        nivel_id: null,
      }));
    } else if (nivelId) {
      setPregunta((prev) => ({
        ...prev,
        nivel_id: parseInt(nivelId),
        tema_id: null,
      }));
    } else {
      console.warn("No se encontró nivel ni tema en la URL.");
      setPregunta((prev) => ({
        ...prev,
        nivel_id: null,
        tema_id: null,
      }));
    }
  }, [location, nivelIdProp, niveles]);

  useEffect(() => {
    if (pregunta.tipo_pregunta === "verdadero_falso") {
      setPregunta((prev) => ({
        ...prev,
        respuestas: [
          { texto_respuesta: "Verdadero", es_correcta: false },
          { texto_respuesta: "Falso", es_correcta: false },
        ],
      }));
    } else {
      setPregunta((prev) => ({
        ...prev,
        respuestas: [
          { texto_respuesta: "", es_correcta: false },
          { texto_respuesta: "", es_correcta: false },
          { texto_respuesta: "", es_correcta: false },
          { texto_respuesta: "", es_correcta: false },
        ],
      }));
    }
  }, [pregunta.tipo_pregunta]);

  const handleChange = (e) => {
    setPregunta({ ...pregunta, [e.target.name]: e.target.value });
  };

  const handleRespuestaChange = (index, e) => {
    const nuevasRespuestas = [...pregunta.respuestas];
    if (e.target.name === "es_correcta") {
      nuevasRespuestas.forEach((respuesta, i) => {
        respuesta.es_correcta = i === index;
      });
    } else {
      nuevasRespuestas[index].texto_respuesta = e.target.value;
    }
    setPregunta({ ...pregunta, respuestas: nuevasRespuestas });
  };

  const enviarPregunta = async (e) => {
    e.preventDefault();

    if (!pregunta.respuestas.some((respuesta) => respuesta.es_correcta)) {
      alert("Debe marcar al menos una respuesta como correcta.");
      return;
    }

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        alert(
          "No se encontró token de autenticación. Por favor, inicie sesión nuevamente."
        );
        return;
      }

      const payload = {
        ...pregunta,
        tema_id: pregunta.tema_id || null,
        nivel_id: pregunta.nivel_id || null,
      };

      console.log("Payload enviado:", payload);

      await axios.post(`${API_BASE_URL}/api/preguntas`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      Swal.fire({
        icon: "success",
        title: "Éxito",
        text: "Pregunta creada con éxito",
        timer: 1500,
        showConfirmButton: false,
      });

      setPregunta({
        tema_id: payload.tema_id,
        nivel_id: payload.nivel_id,
        texto_pregunta: "",
        tipo_pregunta: "opcion_multiple",
        limite_tiempo: 60,
        retroalimentacion: "",
        respuestas: [
          { texto_respuesta: "", es_correcta: false },
          { texto_respuesta: "", es_correcta: false },
          { texto_respuesta: "", es_correcta: false },
          { texto_respuesta: "", es_correcta: false },
        ],
      });
    } catch (error) {
      console.error(
        "Error al crear pregunta:",
        error.response ? error.response.data : error.message
      );
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Error al crear la pregunta y respuestas. Por favor, intenta de nuevo.",
      });
    }
  };

  return {
    niveles,
    pregunta,
    handleChange,
    handleRespuestaChange,
    enviarPregunta,
  };
};

export default useCrearPregunta;
